import {take, put, select, fork} from 'redux-saga/effects';
import {openModal, closeModal} from '@computerrock/formation-router/sagas';
import {RentalCarPricing} from '@ace-de/eua-entity-types';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as serviceProviderActionTypes from '../serviceProviderActionTypes';
import modalIds from '../../modalIds';

const createSPRentalCarPricingFlow = function* createSPRentalCarPricingFlow() {
    const {serviceManager} = yield select(state => state.application);
    const partnerManagementService = serviceManager.loadService('partnerManagementService');

    while (true) {
        const {payload} = yield take(serviceProviderActionTypes.INITIATE_CREATE_SP_RENTAL_CAR_PRICE_DATA_FLOW);
        const {serviceProviderId} = payload;

        yield* openModal(modalIds.SP_RENTAL_CAR_PRICING_DATA);

        const chosenModalOption = yield take([
            serviceProviderActionTypes.CONFIRM_CREATE_SP_RENTAL_CAR_PRICING,
            serviceProviderActionTypes.DECLINE_CREATE_SP_RENTAL_CAR_PRICING,
        ]);

        if (chosenModalOption
            && chosenModalOption.type === serviceProviderActionTypes.CONFIRM_CREATE_SP_RENTAL_CAR_PRICING
        ) {
            const {rentalCarPricingData} = chosenModalOption.payload;

            yield fork(
                fetchRequest,
                serviceProviderActionTypes.CREATE_SP_RENTAL_CAR_PRICING_REQUEST,
                partnerManagementService.createSPRentalCarPricing,
                {
                    rentalCarPricingDTO: RentalCarPricing.objectToDTO(rentalCarPricingData),
                },
            );

            const responseAction = yield take([
                serviceProviderActionTypes.CREATE_SP_RENTAL_CAR_PRICING_REQUEST_SUCCEEDED,
                serviceProviderActionTypes.CREATE_SP_RENTAL_CAR_PRICING_REQUEST_FAILED,
            ]);

            if (!responseAction.error) {
                const {response} = responseAction.payload;
                const {rentalCarPricingDTO} = response;
                const {id: rentalCarPricingId} = rentalCarPricingDTO;

                yield put({
                    type: serviceProviderActionTypes.STORE_SERVICE_PROVIDER_RENTAL_CAR_PRICING,
                    payload: {rentalCarPricingDTOs: [rentalCarPricingDTO], serviceProviderId, rentalCarPricingId},
                });
            }
        }

        yield* closeModal(modalIds.SP_RENTAL_CAR_PRICING_DATA);
    }
};

export default createSPRentalCarPricingFlow;
